export const CURRENCY_VARIABLE_SLUGS = new Set<string>(['cost', 'roi_value_saved', 'roi_value_saved_per_interaction']);

export function isCurrencyVariable(variable?: string): boolean {
  return variable != null && CURRENCY_VARIABLE_SLUGS.has(variable);
}
